function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, CSSProperties, Ref, ReactNode } from 'react';
import cn from 'classnames';
require("./List.css");
var styles = {
  "Root": "List-module-Root_1dJ",
  "isFilled": "List-module-isFilled_2lE",
  "isOutlined": "List-module-isOutlined_1_B"
};
export const ListTags = {
  div: 'div',
  ul: 'ul'
};
export const List = ({
  children,
  className,
  controlRef,
  innerRef,
  style,
  tag = ListTags.div,
  frame
}) => {
  const RootTag = tag;
  return /*#__PURE__*/React.createElement(RootTag, _extends({}, tag === ListTags.div && {
    role: 'list'
  }, {
    className: cn(styles.Root, className, {
      [styles.isFilled]: frame === 'filled'
    }, {
      [styles.isOutlined]: frame === 'outlined'
    }),
    ref: innerRef || controlRef,
    style: style
  }), children);
};
if (process.env.NODE_ENV !== 'production') {
  List.displayName = 'List';
}